module.exports = __webpack_public_path__ + "img/flatwhite-thumb.9d11d8aa.png";